import { Scheme } from "./enums";

export const formatUrl = (url: string, defaultScheme: Scheme | string): string => {
    if (!url) return url;

    const reg: RegExp = /mailto:+[\s\S]+|([\s\S]+:\/\/+[\s\S]+)$/i;
    if (reg.test(url))
        return url;

    return defaultScheme.concat(url);
};

export const prettyPrintUrl = (url: string): string => {
    return url.replace(/mailto:/i, "");
};
